import katex from 'katex';
import 'katex/dist/katex.min.css';

export default defineNuxtPlugin(() => {
  // 全局数学公式渲染函数
  const renderMathContent = (content) => {
    if (!content || typeof content !== 'string') {
      return content;
    }

    try {
      // 处理行内公式 $...$ 或 \(...\)
      content = content.replace(/\$([^$\n]+?)\$/g, (match, formula) => {
        try {
          return katex.renderToString(formula, {
            throwOnError: false,
            errorColor: '#cc0000',
            displayMode: false
          });
        } catch (error) {
          console.warn('KaTeX inline formula error:', error);
          return match; // 如果渲染失败，返回原始内容
        }
      });

      // 处理块级公式 $$...$$ 或 \[...\]
      content = content.replace(/\$\$([^$\n]+?)\$\$/g, (match, formula) => {
        try {
          return katex.renderToString(formula, {
            throwOnError: false,
            errorColor: '#cc0000',
            displayMode: true
          });
        } catch (error) {
          console.warn('KaTeX block formula error:', error);
          return match; // 如果渲染失败，返回原始内容
        }
      });

      // 处理 LaTeX 块级公式 \[...\]
      content = content.replace(/\\\[([^[\n]+?)\\\]/g, (match, formula) => {
        try {
          return katex.renderToString(formula, {
            throwOnError: false,
            errorColor: '#cc0000',
            displayMode: true
          });
        } catch (error) {
          console.warn('KaTeX block formula error:', error);
          return match; // 如果渲染失败，返回原始内容
        }
      });

      // 处理 LaTeX 行内公式 \(...\)
      content = content.replace(/\\\(([^(\n]+?)\\\)/g, (match, formula) => {
        try {
          return katex.renderToString(formula, {
            throwOnError: false,
            errorColor: '#cc0000',
            displayMode: false
          });
        } catch (error) {
          console.warn('KaTeX inline formula error:', error);
          return match; // 如果渲染失败，返回原始内容
        }
      });

      return content;
    } catch (error) {
      console.error('Math content rendering error:', error);
      return content; // 如果整体处理失败，返回原始内容
    }
  };

  // 检查内容是否包含数学公式
  const hasMathContent = (content) => {
    if (!content || typeof content !== 'string') {
      return false;
    }
    
    const mathPatterns = [
      /\$[^$\n]+?\$/g,           // $...$
      /\$\$[^$\n]+?\$\$/g,       // $$...$$
      /\\\[[^[\n]+?\\\]/g,       // \[...\]
      /\\\([^(\n]+?\\\)/g        // \(...\)
    ];
    
    return mathPatterns.some(pattern => pattern.test(content));
  };

  // 手动触发数学公式重新渲染
  const reRenderMath = (container) => {
    if (!container) return;
    
    // 查找所有包含数学公式的元素并重新渲染
    const mathElements = container.querySelectorAll('.katex');
    if (mathElements.length > 0) {
      // 如果已经有 KaTeX 渲染的元素，可能需要重新初始化
      console.log('Math content already rendered');
    }
  };

  return {
    provide: {
      renderMathContent,
      hasMathContent,
      reRenderMath
    }
  };
}); 